import {z} from 'zod';

import {conversationUser} from '../../modules/user/conversationUser';

export const createPublicUserBody = z.object({
  displayName: z
    .string()
    .min(1, 'Display name is required')
    .max(255, 'Display name cannot exceed 255 characters'),
});

export type CreatePublicUserBody = z.infer<typeof createPublicUserBody>;

export const createPublicUserResponse = conversationUser
  .omit({type: true, externalUserId: true})
  .extend({
    type: z.literal('PUBLIC').openapi({
      description: 'Type of user',
      example: 'PUBLIC',
    }),
  });

export type CreatePublicUserResponse = z.infer<typeof createPublicUserResponse>;
